'use client';

import HardCodedHorizontalBannerComponent from '@molecules/HardCodedHorizontalBannerComponent/HardCodedHorizontalBannerComponent';
import Page from '@organisms/Page/Page';
import useCmsPage from '@hooks/useCmsPage';
import cmsLabels from '@constants/cmsLabels';

const label = cmsLabels.HOME;

const HomePageClient = () => {
  const { cmsPage } = useCmsPage(label);

  return <Page cmsPage={cmsPage}>{cmsPage?.uid === 'homePage' && <HardCodedHorizontalBannerComponent />}</Page>;
};

export default HomePageClient;
